<template>
  <div>
    <page-navigate></page-navigate>
      <div id="pageNotFound">
      <div class="pageNavigate"></div>
      <section class="containerPage flex items-center justify-between">
       <div class="leftPart">
        <h1 class="title-40_bold md-subtitle-20_bold">行情有波动，页面也有迷路的时候</h1>
        <h2 class="subtitle-18_regular md-body-14_regular">别被短期的“迷失”打乱节奏，稳住，从这里返回首页。</h2>
         <a
          href="/"
          class="back-btn primary-default_large content-16_medium md-body-14_medium"
        >
          返回首页
        </a>
       </div>
       <video class="pageModel" src="@/assets/image/404/404Model.mp4" autoplay loop muted></video>
      </section>
      <div class="pageFooter"></div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
export default {
  mounted(){
		document.documentElement.setAttribute('data-fitter', 'true');
  },
  destroyed() {
		document.documentElement.removeAttribute('data-fitter');
  },
}

</script>

<style scoped>
#pageNotFound a:hover{
  color: #fff;
}
    #pageNotFound{
        background:#fff;
      }
      .containerPage{
        max-width: 1200rem;
        margin-inline: auto;
        padding-block: 200rem 100rem;
      }
      .containerPage h2{
        margin-block: 20rem 30rem;
        color: var(--ebc-text-tertiary);
      }
      .containerPage a{
        width: fit-content;
        min-width: 115rem;
      }
      .containerPage .leftPart{
        flex: 0 0 365rem;
      }
      @media (min-width: 996px) {
        .ru .containerPage .leftPart,
        .hi .containerPage .leftPart,
        .pt .containerPage .leftPart,
        .vi .containerPage .leftPart,
        .es .containerPage .leftPart,
        .ug .containerPage .leftPart,
        .th .containerPage .leftPart,
        .jp .containerPage .leftPart,
        .en .containerPage .leftPart{
          flex: 0 0 470rem;
        }
        
      }
      .containerPage .pageModel{
        flex:0 0 613rem;
        height:336rem;
        }
        @media (max-width: 996px) {
      .containerPage{
        flex-direction: column;
        padding: 50rem 32rem;
      }
      .containerPage .leftPart{
        order: 2;
        text-align: center;
      }
       .containerPage .pageModel{
        width: 100%;
       }
      .containerPage h2{
        margin-block: 16rem 48rem;
      }
      .containerPage a{
        height: 40px;
        font-size: 14px!important;
        line-height: 22px!important;
        margin-inline: auto;
      }
        }
</style>